export const KubernetesDeployManifestTypes = Object.freeze({
  KUBERNETES: 1,
  COMPOSE: 2,
});
